module.exports = __webpack_public_path__ + "static/media/MapLocation_card_bg_05.b095773d.jpg";